import { render, staticRenderFns } from "./VoicePreviewManage.vue?vue&type=template&id=05f3bf14&"
import script from "./VoicePreviewManage.vue?vue&type=script&lang=js&"
export * from "./VoicePreviewManage.vue?vue&type=script&lang=js&"
import style0 from "./VoicePreviewManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports